import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Mail, Phone, MapPin, MessageSquare, Send, Clock } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    setSending(true);
    // No backend contact endpoint — simulate a successful submit
    setTimeout(() => {
      toast.success("Message sent — we'll reply within 24 hours.");
      setForm({ name: "", email: "", subject: "", message: "" });
      setSending(false);
    }, 600);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 md:px-6 py-12" data-testid="contact-page">
      <div className="max-w-3xl">
        <h1 className="text-4xl md:text-5xl font-display font-semibold">We&rsquo;re here to help</h1>
        <p className="text-muted-foreground mt-3 max-w-xl">Questions about an order, feedback, or want to partner your store with Babu Baazar? Drop us a line.</p>
      </div>

      <div className="grid lg:grid-cols-3 gap-6 mt-10">
        <div className="lg:col-span-1 space-y-3">
          {[
            { icon: Phone, label: "Call us", value: "+91 90000 12345", sub: "10am – 10pm daily" },
            { icon: Mail, label: "Email", value: "hello@babubaazar.in", sub: "Reply within 24 hours" },
            { icon: MapPin, label: "Babu Store", value: "Indiranagar, Bengaluru", sub: "Karnataka, India" },
            { icon: Clock, label: "Support hours", value: "10:00 – 22:00", sub: "All days including holidays" },
          ].map((row, i) => (
            <Card key={i} className="card-soft border-transparent">
              <CardContent className="p-4 flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-accent/10 text-accent grid place-items-center shrink-0">
                  <row.icon className="w-5 h-5" />
                </div>
                <div className="min-w-0">
                  <div className="text-xs uppercase tracking-wider text-muted-foreground">{row.label}</div>
                  <div className="font-medium truncate">{row.value}</div>
                  <div className="text-xs text-muted-foreground">{row.sub}</div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="lg:col-span-2">
          <Card className="card-soft border-transparent">
            <CardContent className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <MessageSquare className="w-4 h-4 text-accent" />
                <div className="font-display text-lg">Send us a message</div>
              </div>
              <form onSubmit={submit} className="grid sm:grid-cols-2 gap-3">
                <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" required /></div>
                <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" required /></div>
                <div className="sm:col-span-2"><Label>Subject</Label><Input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" required /></div>
                <div className="sm:col-span-2"><Label>Message</Label><Textarea rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" required /></div>
                <div className="sm:col-span-2">
                  <Button type="submit" disabled={sending} className="btn-primary-glow" data-testid="contact-submit">
                    <Send className="w-4 h-4 mr-2" />{sending ? "Sending…" : "Send message"}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
